export default {
    methods: {
        /**
         * Format the date to be used in the API.
         *
         * This function makes the time 00:00:00 when it's all day.
         *
         * date = Date object
         * time = Date object (used when creating an event, otherwise it should be the same as date)
         * all_day = boolean
         */
        formatJsDateForApi(date, time, all_day) {
          let new_date = '';

          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');

          // Add the data to the payload
          new_date = year + '-' + month + '-' + day;

          // Add the time if not all day
          if (all_day) {
            new_date += 'T00:00:00';
          }
          else {
            // Add the time
            let timeDate = time;

            const hours = String(timeDate.getHours()).padStart(2, '0');
            const minutes = String(timeDate.getMinutes()).padStart(2, '0');

            new_date += 'T' + hours + ':' + minutes + ':00';
          }

          return new_date;
        },
    }
}
